module.exports = __webpack_public_path__ + "images/notifications/report-14e8943a9c53f0edbd223d91d2d2a7c7.png";